import SectionLayout from "../../components/SectionLayout"
import Skeleton from "../../components/skeleton"
import useFetch from "../../hooks/useFetch"
import SyllabusCard from "./[id]/components/SyllabusCard"

const Exams = () => {
  const { data: syllabus, loading } = useFetch("/syllabus")

  return (
    <section className="w-full space-y-4">
      <SectionLayout title={"All Exams Syllabus"}>
        {!loading ? (
          syllabus?.data?.map((syllabus, index) => (
            <SyllabusCard key={index} data={syllabus} />
          ))
        ) : (
          <div className="flex flex-col gap-2 mt-2">
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
          </div>
        )}
      </SectionLayout>
    </section>
  )

}

export default Exams
